import React from 'react'
import { Card, CardHeader, Table, Button } from 'reactstrap'
import PropTypes from 'prop-types'
import TimeUtil from 'utils/time-util'
import withLoader from 'hocs/with-loader'
import { CardLoader } from 'components/organisms'
import StringUtil from 'utils/string-util'

const propTypes = {
  user: PropTypes.shape({
    id               : PropTypes.number,
    name             : PropTypes.string,
    email            : PropTypes.string,
    mobile           : PropTypes.string,
    birthday         : PropTypes.string,
    gender           : PropTypes.string,
    is_banned        : PropTypes.bool,
    is_banned_reason : PropTypes.string
  }),
  handleClickEditUser: PropTypes.func
}

const defaultProps = {
  handleClickEditUser: () => {}
}

const UserDetailCard = ({
  user,
  handleClickEditUser
}) => (
  <Card>
    <CardHeader>
      <div>
        <span className='small text-uppercase text-light font-weight-bolder'>
          { 'User' }
        </span>
        <h2>
          <span>{ user?.name }</span>
        </h2>
      </div>
    </CardHeader>
    <Table size='sm' responsive hover className='mb-0'>
      <tbody>
        <tr>
          <th scope='row'>ID</th>
          <td>{ user?.id }</td>
        </tr>
        <tr>
          <th scope='row'>Email</th>
          <td>{ user?.email }</td>
        </tr>
        <tr>
          <th scope='row'>Mobile Number</th>
          <td>{ user?.mobile }</td>
        </tr>
        <tr>
          <th scope='row'>Birthday</th>
          <td>{ TimeUtil.format(user?.birthday) }</td>
        </tr>
        <tr>
          <th scope='row'>Gender</th>
          <td className='text-capitalize'>{ user?.gender }</td>
        </tr>
        <tr>
          <th scope='row'>Banned</th>
          <td className='text-capitalize'>{ user?.is_banned ? 'Yes' : 'No' }</td>
        </tr>
        {
          user?.is_banned &&(
            <tr>
              <th scope='row'>Banned Reason</th>
              <td className='text-capitalize'>{ StringUtil.humanize(user?.is_banned_reason) }</td>
            </tr>
          )
        }
      </tbody>
    </Table>
    <Button
      className='m-3'
      color='primary'
      onClick={ () => { handleClickEditUser(user?.id) } }
    >
      { 'Edit User' }
    </Button>

  </Card>
)

UserDetailCard.propTypes    = propTypes
UserDetailCard.defaultProps = defaultProps

export default withLoader(UserDetailCard, CardLoader)
